import React from "react";
import "./Auth.scss";

const AuthLayout = ({ children }: any) => {
  return (
    <div className="authContainer">
      <div className="auth_box">
        {/* <figure className="auth_logo">
          <img src="/static/images/maf_logo.svg" alt="Maf Logo" />
        </figure> */}
        <h1>Car Advertising</h1>
        {children}
      </div>
    </div>
  );
};

export default AuthLayout;
